module.exports = __webpack_public_path__ + "app1.png?bdbd27ffcba32588830410cd18d1f119";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/app1.png
// module id = 15
// module chunks = 0